import React, { createContext, useContext } from "react"
import { FMFile } from "../shared/FMFile"
import Files from "../fmanlibs/Files"
import { IUpload } from "../libs/dragdrop/DragAndDrop"
import Dirs from "../fmanlibs/Dirs"
import { useSnackbar } from "../gui/Snackbar/SnackbarProvider"
import { useFilesProvider } from "../fmanlibs/FilesProvider"
import useUploadDlg from "../components/Upload/UploadDlg"

export type TUploadProviderContext = {
    busy:boolean
    upload:(files:IUpload[]) => Promise<void>
}
const UploadContext = createContext<TUploadProviderContext>({} as any)
export const useUploadProvider = () => useContext(UploadContext)

export default function UploadProvider(props:{children:React.ReactNode}) {
    const {addSnackbar} = useSnackbar()
    const {root} = useFilesProvider()
    const {busy,showUploads,setBusy} = useUploadDlg()

    const upload = async (files:IUpload[]) => {
        if (busy || !root) return
        else setBusy(true)

        const paths = Array.from(new Set(files.map(file => file.path))).sort((l,r) => l.length>r.length ? -1 : 1).filter(p => !!p)
        let didCreate = false

        for(let path of paths) try {
            if (!await Dirs.i.findPath(root._id, path)) {
                await Dirs.i.createPath(root._id, path)
                didCreate = true
            }            
        }catch(e){
            addSnackbar(e)
            return setBusy(false)
        }

        let parent:FMFile
        if (didCreate) parent = await Files.i.expire(root._id).get(root._id)
        else parent = root

        showUploads(root, files)
    }

    return <UploadContext.Provider value={{busy,upload}}>{props.children}</UploadContext.Provider>
}